import { useEffect } from "react";
import {
  detectMobileOs,
  IOS_BOTTOM_SAFE_SUBTRACT_PX,
  mobileOsHtmlClass,
  type MobileOsKind,
} from "./bottomSafeHeight";

const OS_CLASSES: MobileOsKind[] = ["ios", "android", "other"];

/** 全局：html OS 类名 + iOS 底部安全区减量（供 --lf-bottom-safe-height 计算） */
export function useMobileOsLayout(enabled = true): void {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }
    const root = document.documentElement;
    const os = detectMobileOs();
    root.style.setProperty(
      "--lf-ios-bottom-safe-subtract",
      `${IOS_BOTTOM_SAFE_SUBTRACT_PX}px`
    );
    OS_CLASSES.forEach((kind) => root.classList.remove(mobileOsHtmlClass(kind)));
    root.classList.add(mobileOsHtmlClass(os));

    return () => {
      OS_CLASSES.forEach((kind) => root.classList.remove(mobileOsHtmlClass(kind)));
      root.style.removeProperty("--lf-ios-bottom-safe-subtract");
    };
  }, [enabled]);
}
